export default [
  {
    path: '/users',
    name: 'users',
    component: () => import('@/views/modules/Administrator/userManagement/index.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
      {
        text: 'sidebar.administration',
        active: true,
      },
      {
        text: 'user.users',
        active: true,
      },
      ],
    },
  },
  {
    path: '/users/edit/:id',
    name: 'users-edit',
    component: () => import('@/views/modules/Administrator/userManagement/edit.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'sidebar.administration',
          active: true,
        },
        {
          text: 'user.users',
          active: false,
          to: '/users',
        },
        {
          text: 'edit',
          active: true,
        },
      ],
    },
  },
  // {
  //   path: '/roles',
  //   name: 'roles',
  //   component: () => import('@/views/modules/Administrator/roles/index.vue'),
  //   meta: {
  //     pageTitle: '',
  //     breadcrumb: [{
  //       text: 'Администрирование',
  //       active: false,
  //     },
  //     {
  //       text: 'Роли',
  //       active: true,
  //     },
  //     ],
  //   },
  // },
]
